module.exports = ".temporary {\n  padding: 1rem;\n}\n"